/* ARTMiE PDP Gallery — standalone vanilla JS
   Touch/swipe on mobile, dots, thumbnail clicks, nav arrows, lightbox, variant switching.
   Replaces the ES-module component-custom-pdp-gallery.js that could never load. */

(function () {
  'use strict';

  function initGallery(gallery) {
    if (!gallery || gallery._artmieInit) return;
    gallery._artmieInit = true;

    var slides = gallery.querySelectorAll('[data-slide-index]');
    var thumbs = gallery.querySelectorAll('[data-thumbnail-index]');
    var dots = gallery.querySelectorAll('[data-dot-index]');
    var galleryMain = gallery.querySelector('[data-gallery-main]');
    var thumbsList = gallery.querySelector('[data-thumbnails-list]');
    var navUp = gallery.querySelector('[data-thumbnail-nav="up"]');
    var navDown = gallery.querySelector('[data-thumbnail-nav="down"]');
    var mainPrev = gallery.querySelector('[data-main-nav="prev"]');
    var mainNext = gallery.querySelector('[data-main-nav="next"]');
    var lightbox = gallery.querySelector('[data-lightbox]');
    var lightboxContent = gallery.querySelector('[data-lightbox-content]');
    var lightboxClose = gallery.querySelector('[data-lightbox-close]');
    var lightboxPrev = gallery.querySelector('[data-lightbox-nav="prev"]');
    var lightboxNext = gallery.querySelector('[data-lightbox-nav="next"]');

    if (!slides.length) return;

    var lightboxIndex = 0;

    /* ── Helpers ── */
    function getActiveIndex() {
      var idx = -1;
      slides.forEach(function (s, i) {
        if (s.classList.contains('custom-pdp-gallery__slide--active')) idx = i;
      });
      return idx;
    }

    function setActiveSlide(index) {
      slides.forEach(function (s, i) {
        s.classList.toggle('custom-pdp-gallery__slide--active', i === index);
      });
    }

    function setActiveThumb(index) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('custom-pdp-gallery__thumbnail--active', i === index);
      });
    }

    function setActiveDot(index) {
      dots.forEach(function (d, i) {
        d.classList.toggle('custom-pdp-gallery__dot--active', i === index);
      });
    }

    function scrollThumbIntoView(thumb) {
      if (!thumbsList || !thumb) return;
      var cRect = thumbsList.getBoundingClientRect();
      var tRect = thumb.getBoundingClientRect();
      if (tRect.top < cRect.top) {
        thumbsList.scrollTop -= cRect.top - tRect.top + 10;
      } else if (tRect.bottom > cRect.bottom) {
        thumbsList.scrollTop += tRect.bottom - cRect.bottom + 10;
      }
    }

    function navigateToSlide(index) {
      if (index < 0 || index >= slides.length) return;
      setActiveSlide(index);
      setActiveThumb(index);
      setActiveDot(index);
      if (thumbs[index]) scrollThumbIntoView(thumbs[index]);
    }

    function updateThumbNavButtons() {
      if (!thumbsList || !navUp || !navDown) return;
      var st = thumbsList.scrollTop;
      var sh = thumbsList.scrollHeight;
      var ch = thumbsList.clientHeight;
      navUp.disabled = st <= 0;
      navDown.disabled = st + ch >= sh - 1;
    }

    /* ── Thumbnail clicks ── */
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var idx = parseInt(t.dataset.thumbnailIndex, 10);
        if (!isNaN(idx)) navigateToSlide(idx);
      });
    });

    /* ── Thumbnail nav arrows ── */
    function scrollThumbs(direction) {
      if (!thumbsList) return;
      var thumb = thumbsList.querySelector('.custom-pdp-gallery__thumbnail');
      var amount = (thumb ? thumb.offsetHeight : 92) + 24;
      var cur = thumbsList.scrollTop;
      var max = thumbsList.scrollHeight - thumbsList.clientHeight;
      thumbsList.scrollTo({
        top: direction === 'up' ? Math.max(0, cur - amount) : Math.min(max, cur + amount),
        behavior: 'smooth'
      });
      setTimeout(updateThumbNavButtons, 300);
    }
    if (navUp) navUp.addEventListener('click', function () { scrollThumbs('up'); });
    if (navDown) navDown.addEventListener('click', function () { scrollThumbs('down'); });
    if (thumbsList) thumbsList.addEventListener('scroll', updateThumbNavButtons);
    updateThumbNavButtons();

    /* ── Main nav prev/next ── */
    if (slides.length > 1) {
      if (mainPrev) mainPrev.addEventListener('click', function () {
        var cur = getActiveIndex();
        navigateToSlide((cur - 1 + slides.length) % slides.length);
      });
      if (mainNext) mainNext.addEventListener('click', function () {
        var cur = getActiveIndex();
        navigateToSlide((cur + 1) % slides.length);
      });
    }

    /* ── Dot clicks ── */
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var idx = parseInt(d.dataset.dotIndex, 10);
        if (!isNaN(idx)) navigateToSlide(idx);
      });
    });

    /* ── Touch / Swipe (mobile) ── */
    if (galleryMain && slides.length > 1) {
      var touchStartX = 0;
      var touchStartY = 0;
      var isDragging = false;

      galleryMain.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        isDragging = true;
        galleryMain.classList.add('is-dragging');
      }, { passive: true });

      galleryMain.addEventListener('touchmove', function (e) {
        if (!isDragging || !e.changedTouches[0]) return;
        var dx = Math.abs(touchStartX - e.changedTouches[0].screenX);
        var dy = Math.abs(touchStartY - e.changedTouches[0].screenY);
        /* Prevent default only if horizontal swipe */
        if (dx > 10 && dx > dy) e.preventDefault();
      }, { passive: false });

      galleryMain.addEventListener('touchend', function (e) {
        if (!isDragging) return;
        var endX = e.changedTouches && e.changedTouches[0]
          ? e.changedTouches[0].screenX
          : touchStartX;
        var diff = touchStartX - endX;
        isDragging = false;
        galleryMain.classList.remove('is-dragging');

        if (Math.abs(diff) < 50) return; /* threshold */
        var cur = getActiveIndex();
        if (diff > 0) {
          navigateToSlide((cur + 1) % slides.length); /* swipe left → next */
        } else {
          navigateToSlide((cur - 1 + slides.length) % slides.length); /* swipe right → prev */
        }
      }, { passive: true });

      galleryMain.addEventListener('touchcancel', function () {
        isDragging = false;
        galleryMain.classList.remove('is-dragging');
      }, { passive: true });
    }

    /* ── Zoom / Lightbox ── */
    function renderLightbox(index) {
      if (!lightboxContent) return;
      lightboxIndex = index;
      var slide = slides[index];
      if (!slide) return;
      var type = slide.dataset.mediaType;
      lightboxContent.innerHTML = '';

      if (type === 'image') {
        var src = slide.dataset.zoomSrc;
        if (!src) {
          var img = slide.querySelector('img.custom-pdp-gallery__main-image');
          if (img) src = img.currentSrc || img.src;
        }
        if (!src) return;
        var hi = document.createElement('img');
        hi.src = src;
        hi.alt = slide.dataset.zoomAlt || '';
        hi.className = 'custom-pdp-gallery__lightbox-image';
        lightboxContent.appendChild(hi);
      } else if (type === 'video') {
        var video = slide.querySelector('video');
        if (video) lightboxContent.appendChild(video.cloneNode(true));
      } else if (type === 'external_video') {
        var iframe = slide.querySelector('iframe');
        if (iframe) lightboxContent.appendChild(iframe.cloneNode(true));
      }
    }

    function openLightbox(index) {
      if (!lightbox) return;
      renderLightbox(index);
      try { lightbox.showModal(); } catch (e) { lightbox.setAttribute('open', ''); }
      lightbox.setAttribute('aria-modal', 'true');
      if (lightboxClose) lightboxClose.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      try { lightbox.close(); } catch (e) {}
      lightbox.removeAttribute('open');
      lightbox.removeAttribute('aria-modal');
    }

    function navLightbox(dir) {
      var next = lightboxIndex;
      if (dir === 'prev') next = (next - 1 + slides.length) % slides.length;
      else next = (next + 1) % slides.length;
      renderLightbox(next);
      setActiveSlide(next);
      setActiveThumb(next);
      setActiveDot(next);
    }

    /* Zoom trigger clicks */
    gallery.querySelectorAll('[data-zoom-trigger], .custom-pdp-gallery__zoom-trigger').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var slide = btn.closest('[data-slide-index]');
        var idx = slide ? parseInt(slide.dataset.slideIndex, 10) : getActiveIndex();
        openLightbox(idx);
      });
    });

    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    if (lightboxPrev) lightboxPrev.addEventListener('click', function () { navLightbox('prev'); });
    if (lightboxNext) lightboxNext.addEventListener('click', function () { navLightbox('next'); });

    if (lightbox) {
      lightbox.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); closeLightbox(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); navLightbox('prev'); }
        if (e.key === 'ArrowRight') { e.preventDefault(); navLightbox('next'); }
      });
    }

    /* ── Variant switching: listen for variant:change from the picker ── */
    var section = gallery.closest('.custom-pdp-section');
    if (section) {
      section.addEventListener('variant:change', function (e) {
        var variantId = e.detail && e.detail.variantId;
        if (!variantId) return;

        /* Read variant data from the JSON script block */
        var jsonScript = section.querySelector('script[data-pdp-variants]');
        if (!jsonScript) return;
        var variants;
        try { variants = JSON.parse(jsonScript.textContent || '[]'); } catch (ex) { return; }

        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(variantId)) { variant = variants[i]; break; }
        }
        if (!variant || !variant.featured_media_id) return;

        var mediaId = String(variant.featured_media_id);
        var targetIndex = -1;
        slides.forEach(function (slide, idx) {
          if (String(slide.getAttribute('data-media-id')) === mediaId) targetIndex = idx;
        });
        if (targetIndex >= 0) navigateToSlide(targetIndex);
      });
    }

    /* ── Expose navigateToSlide for external callers ── */
    gallery.navigateToSlide = navigateToSlide;
    gallery.getActiveIndex = getActiveIndex;
  }

  /* ── Init on DOM ready ── */
  function init() {
    document.querySelectorAll('custom-pdp-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Also handle dynamically loaded galleries */
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          if (node.tagName === 'CUSTOM-PDP-GALLERY') initGallery(node);
          var nested = node.querySelectorAll ? node.querySelectorAll('custom-pdp-gallery') : [];
          nested.forEach(initGallery);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

})();
